module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "flag",
    class: [_vm.colorClass]
  }, [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff33f6be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/flag/Flag.vue
// module id = 2003
// module chunks = 0